import * as React from "react";
import { Typography, Stack } from "../mui";

import "../../styles/components/pageHeader.css";

export default function PageHeader({ 
  icon: Icon, 
  eyebrow, 
  title, 
  summary,
  summaryExtra,
  actions, 
  className = "" 
}) {
  return (
    <header className={`page-header ${className}`.trim()}>
      <div className="page-header-heading">
        {Icon && (
          <div className="page-header-heading-icon">
            <Icon fontSize="inherit" />
          </div>
        )}
        <div className="page-header-heading-content">
          {eyebrow && (
            <Typography variant="overline" className="page-header-eyebrow">
              {eyebrow}
            </Typography>
          )}
          <Typography variant="h5" className="page-header-title">
            {title}
          </Typography>
          {summary && (
            <Typography variant="body1" className="page-header-summary">
              {summary}
            </Typography>
          )}
          {summaryExtra && (
            <div className="page-header-summary-extra">
              {summaryExtra}
            </div>
          )}
        </div>
      </div>

      {actions && (
        <Stack direction="row" spacing={1.5} flexWrap="wrap" className="page-header-actions">
          {actions}
        </Stack>
      )}
    </header>
  );
}
